export const APOLLO_CACHE_SCRIPT_ID = "apollo-state";
export const APP_CTX_SCRIPT_ID = "app-ctx";
export const APP_CMS_ROUTES_SCRIPT_ID = "app-dynamic-routes";

